const ActionType = require("action-types/users");
const SnackbarActions = require("./snackbar");
const WebClient = require("utils/web-client");
const Deeply = require("utils/deeply");
const History = require("wiring/history");

const actions = exports;

exports.deleteUserBegin = () => {
    return {
        type: ActionType.DELETE_USER_BEGIN
    };
};

exports.deleteUserFailure = () => {
    return {
        type: ActionType.DELETE_USER_FAILURE
    };
};

exports.deleteUserSuccess = id => {
    return {
        type: ActionType.DELETE_USER_SUCCESS,
        payload: { id }
    };
};

exports.deleteUser = id => {
    return dispatch => {
        dispatch(actions.deleteUserBegin());

        return WebClient.delete("/users/" + id)
            .then(() => {
                dispatch(actions.deleteUserSuccess(id));
                dispatch(
                    SnackbarActions.messageSnackbar("User deleted successfully")
                );
            })
            .catch(error => {
                dispatch(actions.deleteUserFailure());
                dispatch(SnackbarActions.messageSnackbar(error.message));
            });
    };
};

exports.fetchUsersBegin = () => {
    return {
        type: ActionType.FETCH_USERS_BEGIN
    };
};

exports.fetchUsersFailure = () => {
    return {
        type: ActionType.FETCH_USERS_FAILURE
    };
};

exports.fetchUsersSuccess = items => {
    return {
        type: ActionType.FETCH_USERS_SUCCESS,
        payload: { items }
    };
};

exports.fetchUsers = () => {
    return dispatch => {
        dispatch(actions.fetchUsersBegin());

        return WebClient.get("/users")
            .then(({ data }) => {
                dispatch(actions.fetchUsersSuccess(data));
            })
            .catch(error => {
                console.error(error);
                dispatch(actions.fetchUsersFailure());
                dispatch(SnackbarActions.messageSnackbar(error.message));
            });
    };
};



// WEBPACK FOOTER //
// ./src/actions/users.js